var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2188_28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9998 4.60255V5.69206C30.8701 6.91806 30.2704 8.02819 29.376 8.92297L10.4787 27.8262C10.3507 27.9542 10.1913 28.0761 10.0282 28.1307L1.46718 31.0007H0.983318C0.393344 30.846 -0.175407 30.1944 0.0501531 29.515L2.85268 21.0768C2.91574 20.8875 3.01094 20.7104 3.15828 20.563L22.243 1.47719C23.6897 0.030987 25.875 -0.394867 27.8038 0.385259C29.5155 1.07742 30.7621 2.70319 30.9992 4.60316L30.9998 4.60255ZM27.4479 7.37364C28.7903 6.40424 28.9716 4.43209 27.791 3.23763C26.6026 2.03529 24.6399 2.20151 23.6273 3.55065L27.4485 7.37364H27.4479ZM9.58675 25.2862L25.7652 9.10253L21.9053 5.24133L5.72736 21.4244L9.58675 25.2856V25.2862ZM7.35479 26.4667L4.54499 23.6616L3.14191 27.8729L7.35419 26.4667H7.35479Z",
    fill: "#19147E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2188_28"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.454984445d85d7618baff3e5885f61b6.svg";
export { ForwardRef as ReactComponent };